<ara-side-nav #navbar class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mobile-view">
    <div id="mapChart"></div>
    <p-messages [value]="mapMessage"></p-messages>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mobile-view details-container">
    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
      <strong>Permit Status</strong>
      <p-table dataKey="id" [value]="permitStatusTable">
        <ng-template pTemplate="header">
          <tr>
            <th>Status</th>
            <th>Count</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-permit>
          <tr>
            <td *ngIf="permit.Status=='Total'"><a (click)="mapData(permit.Status)"><strong>{{permit.Status}}</strong></a></td>
            <td *ngIf="permit.Status!='Total'"><a (click)="mapData(permit.Status)">{{permit.Status}}</a></td>
            <td><a (click)="mapData(permit.Status)">{{permit.Count}}</a></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
      <strong>Permit Types</strong>
      <p-table dataKey="id" [value]="permitTypeTable">
        <ng-template pTemplate="header">
          <tr>
            <th>Permit Type</th>
            <th>Count</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-permit>
          <tr>
            <td *ngIf="permit.PermitType=='Total'"><strong>{{permit.PermitType}}</strong></td>
            <td *ngIf="permit.PermitType!='Total'">{{permit.PermitType}}</td>
            <td>{{permit.Count}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
 <span *ngIf="showPermit">
  <p-dialog header="Permits" [(visible)]="showPermit" [modal]="true">
    <div class="table-responsive design-table">
      <table class="table table-hover table-striped">
          <thead>
              <tr>
                  <th style="width:50px">Sr.No</th>
                  <th>Permit Number</th> 
                  <th>Status</th>            
              </tr>
          </thead>
          <tbody>            
            <ng-Container *ngFor="let data of permitData;let i = index" style=" display: contents;">
            <tr [ngClass]="getClassName(data.PermitType)">               
                  <td (click)="Redirect(data.PermitId)" style="width:50px;padding-left: 10px;">{{i+1}}</td>
                  <td><a  (click)="Redirect(data.PermitId)" style="padding-left:10px;">{{data.PermitNumber}}</a></td>
                  <td><a (click)="Redirect(data.PermitId)" style="padding-left:10px;">{{data.Status}}</a></td>                  
            </tr>
            </ng-Container>  
          </tbody>
      </table>
      <div *ngIf="permitData?.length === 0" class="no-record-found">No Records Found</div>    
  </div>
  </p-dialog> 
</span>